import React from "react";
import { NavLink } from "react-router-dom";
import s from './Nav.module.scss'

const NavItem = ({ link, icon, title }) => {
  return (
    <NavLink activeClassName={s.active} className={s.link} to={link}>
      <i className={`fa-solid ${icon}`} ></i>{title}
    </NavLink>
  );
}

const Nav = (props) => {
  return (
    <nav className={s.nav}>
      <NavItem title='Profile' link='/profile' icon='fa-address-card' />
      <NavItem title='Users' link='/users' icon='fa-users' />
      <NavItem title='Messages' link='/chat' icon='fa-message' />
      <NavItem title='News' link='/news' icon='fa-newspaper' />
      <NavItem title='Settings' link='/settings' icon='fa-gear' />
      <NavItem title='Login' link='/login' icon='fa-gear' />
    </nav>
  );
}

export default Nav;